"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceByTaxConfig = exports.getPriceAfterTax = exports.getPriceBeforeTax = exports.calculateTaxExclusive = exports.calculateTaxInclusive = exports.getTaxAmount = exports.toDecimalPlaces = exports.toThreeDecimalPlaces = exports.toTwoDecimalPlaces = void 0;
const DEFAULT_DECIMAL_PLACES = 2;
const toTwoDecimalPlaces = (value) => {
    if (!value)
        return 0;
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num))
        return 0;
    return parseFloat(num.toFixed(2));
};
exports.toTwoDecimalPlaces = toTwoDecimalPlaces;
const toThreeDecimalPlaces = (value) => {
    if (!value)
        return 0;
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num))
        return 0;
    return parseFloat(num.toFixed(3));
};
exports.toThreeDecimalPlaces = toThreeDecimalPlaces;
const toDecimalPlaces = (value, places = DEFAULT_DECIMAL_PLACES) => {
    if (!value)
        return 0;
    const num = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(num))
        return 0;
    return parseFloat(num.toFixed(places));
};
exports.toDecimalPlaces = toDecimalPlaces;
const getTaxAmount = (price, taxRate, decimalPlaces = DEFAULT_DECIMAL_PLACES) => {
    return (0, exports.toDecimalPlaces)((price * taxRate) / 100, decimalPlaces);
};
exports.getTaxAmount = getTaxAmount;
const calculateTaxInclusive = (price, taxRate, decimalPlaces = DEFAULT_DECIMAL_PLACES) => {
    return (0, exports.toDecimalPlaces)(price + (price * taxRate) / 100, decimalPlaces);
};
exports.calculateTaxInclusive = calculateTaxInclusive;
const calculateTaxExclusive = (price, taxRate, decimalPlaces = DEFAULT_DECIMAL_PLACES) => {
    return (0, exports.toDecimalPlaces)(price / (1 + taxRate / 100), decimalPlaces);
};
exports.calculateTaxExclusive = calculateTaxExclusive;
const getPriceBeforeTax = (price, priceIsTaxInclusive, taxRate, decimalPlaces = DEFAULT_DECIMAL_PLACES) => {
    if (price === null || price === undefined)
        return 0;
    if (typeof price === 'string') {
        price = parseFloat(price);
    }
    if (priceIsTaxInclusive) {
        return (0, exports.calculateTaxExclusive)(price, taxRate, decimalPlaces);
    }
    else {
        return (0, exports.toDecimalPlaces)(price, decimalPlaces);
    }
};
exports.getPriceBeforeTax = getPriceBeforeTax;
const getPriceAfterTax = (price, priceIsTaxInclusive, taxRate, decimalPlaces = DEFAULT_DECIMAL_PLACES) => {
    if (price === null || price === undefined)
        return 0;
    if (typeof price === 'string') {
        price = parseFloat(price);
    }
    if (priceIsTaxInclusive) {
        return (0, exports.toDecimalPlaces)(price, decimalPlaces);
    }
    else {
        return (0, exports.calculateTaxInclusive)(price, taxRate, decimalPlaces);
    }
};
exports.getPriceAfterTax = getPriceAfterTax;
const getPriceByTaxConfig = (price, priceIsTaxInclusive, taxRate, taxType, decimalPlaces = DEFAULT_DECIMAL_PLACES) => {
    if (price === null || price === undefined)
        return 0;
    if (typeof price === 'string') {
        price = parseFloat(price);
    }
    if (taxType === 'inclusive') {
        return (0, exports.getPriceAfterTax)(price, priceIsTaxInclusive, taxRate, decimalPlaces);
    }
    else if (taxType === 'exclusive') {
        return (0, exports.getPriceBeforeTax)(price, priceIsTaxInclusive, taxRate, decimalPlaces);
    }
    else {
        return price;
    }
};
exports.getPriceByTaxConfig = getPriceByTaxConfig;
//# sourceMappingURL=tax.js.map